import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 本文件用于兼容标准容器下的 MSI 桥调用，标准容器下的部分 MSI 桥调用与非标准容器下的 MSI 桥调用不一致，所以需要自定义实现
 * 本文件代码均来自 msi 仓库，仅做了部分修改，以兼容标准容器下的 MSI 桥调用
 * 参考文档：
 * https://km.sankuai.com/collabpage/2717924744
 * https://km.sankuai.com/collabpage/2719587967
 */
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
import { msi } from '@mtfe/msi-knb-loader';
// MSI 桥回调结果-桥通信基础字段映射
export var commonBridgeOutputKeyMap = {
  errorCode: 'errCode',
  errorMsg: 'errMsg',
  status: 'mmp.status'
};
export var commonBridgeSuccOutputKeyMap = {
  status: function status() {
    return 'success';
  },
  errorMsg: function errorMsg() {
    return '';
  },
  errorCode: function errorCode() {
    return 0;
  }
};
export var commonBridgeInputKeyMap = {};
export var emptyFn = function emptyFn() {};
/**
 * 判断是否是非空对象
 */
export var isNonEmptyObject = function isNonEmptyObject(variable) {
  return _typeof(variable) === 'object' && variable !== null && Object.keys(variable).length > 0;
};
export var isString = function isString(value) {
  return typeof value === 'string';
};
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
export var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null && !Array.isArray(value);
};
/**
 * 适配逻辑：key 字段映射，value 不做处理
 * @param inputJson
 * @param mapping 映射文件 { key: KNB字段 value: MSI字段 }
 * @param mapKeyAsInput 映射文件的Key是输入JSON的字段，如MSI桥输出转KNB结构时传false、KNB输入转MSI结构时传true
 * @returns
 */
export var getMappedData = function getMappedData(inputJson, mapping, mapKeyAsInput) {
  if (mapKeyAsInput === void 0) {
    mapKeyAsInput = true;
  }
  var isValidDataAndKeyMap = isNonEmptyObject(inputJson) && isNonEmptyObject(mapping);
  // 适配对象和映射关系需要是有效对象
  if (!isValidDataAndKeyMap) {
    // 如果无法映射，那么返回原对象
    return inputJson;
  }
  var outputJson = {};
  // 辅助函数，用于根据路径获取嵌套对象的值
  function getNestedValue(base, path) {
    var pathArray = Array.isArray(path) ? path : [path];
    var current = base;
    for (var i = 0; i < pathArray.length; i++) {
      if (current === null || typeof current[pathArray[i]] === 'undefined') {
        return undefined;
      }
      current = current[pathArray[i]];
    }
    return current;
  }
  // 辅助函数，用于根据路径数组设置嵌套对象的值
  function setNestedValue(base, pathArray, value) {
    var current = base;
    for (var i = 0; i < pathArray.length - 1; i++) {
      var key = pathArray[i];
      if (typeof current[key] === 'undefined' || current[key] === null) {
        current[key] = {};
      }
      current = current[key];
    }
    current[pathArray[pathArray.length - 1]] = value;
  }
  // 根据mapKeyAsInput决定处理方式
  Object.keys(mapping).forEach(function (key) {
    var path = mapping[key];
    var value = function () {
      if (isObject(path)) {
        return path.value(inputJson);
      }
      if (isFunction(path)) {
        return path(inputJson);
      }
      return getNestedValue(inputJson, mapKeyAsInput ? key : path);
    }();
    if (typeof value !== 'undefined') {
      var outputPath = mapKeyAsInput ? path : key;
      var pathArray = [];
      if (Array.isArray(outputPath)) {
        pathArray = outputPath;
      } else if (isString(outputPath)) {
        pathArray = outputPath.split('.');
      } else if (isFunction(outputPath)) {
        pathArray = outputPath(inputJson);
      } else if (isObject(outputPath) && outputPath.key) {
        pathArray = outputPath.key.split('.');
      }
      setNestedValue(outputJson, pathArray, value);
    }
  });
  return __assign({}, inputJson, outputJson);
};
export var knbToMsiMapper = function knbToMsiMapper(inputJson, mapping) {
  return getMappedData(inputJson, mapping, true);
};
export var msiToKnbMapper = function msiToKnbMapper(inputJson, mapping) {
  return getMappedData(inputJson, mapping, false);
};
export var mixin = function mixin(a, b, c, d, e, f) {
  var objs = [b, c, d, e, f].filter(Boolean);
  var target = a || {};
  objs.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
};
function stringify(params) {
  return Object.keys(params).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
}
export function concatSchemeURL(scheme, urlKey, url, query) {
  var urlObject = {};
  urlObject[urlKey] = url;
  return scheme + "?" + stringify(mixin(urlObject, query));
}
/**
 * KNB 桥调用链路阻塞回调
 */
export var knbBridgeBreakCallback = function knbBridgeBreakCallback(customFailCallBack, errorMsg, errorCode) {
  if (errorCode === void 0) {
    errorCode = -1;
  }
  customFailCallBack({
    errorCode: errorCode,
    status: 'fail',
    errorMsg: errorMsg
  });
};
/**
 * 自定义 MSI 跳转页面
 * @param knbParams KNB 桥参数
 * 由于msi的跳转函数 https://msi-extend.sankuai.com/api?tab=C&id=1424 和KNB.jumpPage（https://km.sankuai.com/page/418144084?from=citadel_collabpage）的实现不一致
 * 根据msi的同学反馈，需要参考容器提供的 KNB-MSI适配层源码 自定义实现
 * 参考文档：
 * https://km.sankuai.com/collabpage/2717924744#b-741985da8fc94588a003dcc19039cefd
 * KNB-MSI适配层源码：https://km.sankuai.com/collabpage/2719587967
 */
var customMsiJumpPage = function customMsiJumpPage(knbParams) {
  var url = knbParams.url,
    _a = knbParams.qs,
    qs = _a === void 0 ? {} : _a,
    _b = knbParams.query,
    query = _b === void 0 ? {} : _b,
    _c = knbParams.success,
    _success = _c === void 0 ? emptyFn : _c,
    _d = knbParams.fail,
    _fail = _d === void 0 ? emptyFn : _d;
  var inputParamsKeyMap = {
    url: 'url'
  };
  var successKeyMap = commonBridgeOutputKeyMap;
  var failKeyMap = commonBridgeOutputKeyMap;
  var statics = {
    localScheme: {
      meituan: 'imeituan://www.meituan.com/web',
      dianping: 'dianping://web'
    },
    defaultUrlKey: 'url'
  };
  var localScheme = statics.localScheme,
    defaultUrlKey = statics.defaultUrlKey;
  var msiParams = __assign({}, knbToMsiMapper(knbParams, inputParamsKeyMap), {
    success: function success(res) {
      _success(msiToKnbMapper(res, successKeyMap));
    },
    fail: function fail(res) {
      return _fail(msiToKnbMapper(res, failKeyMap));
    }
  });
  if (/^http:|^https:|^\/\//i.test(url)) {
    // https链接需要拼接scheme
    try {
      var result = msi.getAppBaseInfo();
      var matches = result._mt.containerConfig.scheme.match(/(.*)\?(.*)/);
      if (matches) {
        var scheme = matches[1] || localScheme['meituan'];
        var urlKey = matches[2] || defaultUrlKey;
        var urlQuery = mixin({}, qs, query);
        msi.jumpToLink(__assign({}, msiParams, {
          url: concatSchemeURL(scheme, urlKey, url, urlQuery)
        }));
      } else {
        knbBridgeBreakCallback(_fail, 'Failed to get the scheme url');
      }
    } catch (error) {
      _fail(msiToKnbMapper(error, failKeyMap));
    }
  } else {
    msi.jumpToLink(__assign({}, msiParams));
  }
};
export var customMsi = {
  jumpToLink: customMsiJumpPage
};